import { useTranslation } from 'react-i18next';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useDispatch } from 'react-redux';
import { HttpError, RQAPICallWithData } from 'store/APIClient';

const editProject = async ({
    payload,
    projectId,
}: {
    payload: { name: string };
    projectId: number;
}) => {
    const response = await RQAPICallWithData<{ message: string }>({
        endpoint: `projects/${projectId}`,
        method: 'PATCH',
        body: payload,
    });
    return response.content.data;
};

export const useUpdateProject = () => {
    const queryClient = useQueryClient();
    const dispatch = useDispatch();
    const { t } = useTranslation();

    return useMutation<
        { message: string },
        { message: string },
        unknown,
        HttpError
    >({
        mutationFn: ({
            projectId,
            newName,
        }: {
            projectId: number;
            newName: string;
        }) => editProject({ payload: { name: newName }, projectId }),

        onSuccess: () => {
            queryClient.invalidateQueries({
                queryKey: ['projects'],
            });
            dispatch.vision.notifyUser({
                message: t('adminBudgetSpace.editProjectModal.editSuccess'),
                snackType: 'success',
            });
        },

        onError: (error) => {
            dispatch.vision.notifyUser({
                message: error.message,
                snackType: 'error',
            });
        },
    });
};
